<div class="container-fluid">
     <div class="row">

          <div class="col-md-12 mb-1">
      <div class="breadcrumb-title border-0">
        <app-list-header [title]="'SUPPORT_TICKET.Support Ticket' | translate" icon="bi bi-envelope"
          [$parent]="getSelf()">
                    </app-list-header>
               </div>
          </div>

          <div class="col-md-12 mt-1">
               <div class="card">
                    <div class="card-body">
                         <p *ngIf="form['error'] == false && form['message']">
                              <app-ncs-alert [message]="form['message']" type="success" />
                         </p>
                         <p *ngIf="form['error'] ==  true && form['message']">
                              <app-ncs-alert [message]="form['message']" type="danger" />
                         </p>
                         <form class="px-3 py-3 mb-2" #uiForm="ngForm">
                              <div class="row">
                                   <div class="mb-2" *ngFor="let e of filterAttributes(); let i = index">
                                        <div class="col-{{getColums( e , form.data.columns)}}">
                  <label for="title" class="form-label" *ngIf="e['type']!=='file'">{{getFilterLable(e["label"]) |
                    translate}}
                                             </label>

                  <div
                    *ngIf="e['refKey']!=1 && e['type']!=='list'  && e['type']!=='file' && e['type']!=='map'  && e['type']!=='textarea'"
                                                  class="mb-2">
                                                  <div class="d-flex align-items-center">
                      <input required="{{e['required']==1}}" [type]="getInputType(e.type)"
                        [(ngModel)]="form.data[e.code]" class="form-control form-control-sm" id="{{e.code}}"
                        name="{{e.code}}" [placeholder]="getFilterLable(e.label) | translate">
                                                  </div>
                                             </div>

                                             <!-- Text Area List  -->
                                             <div *ngIf="e['type']==='textarea'" class="mb-2">
                                                  <div class="d-flex align-items-center">
                      <textarea required="{{e['required']==1}}" [(ngModel)]="form.data[e.code]"
                        class="form-control form-control-sm" id="{{e.code}}" name="{{e.code}}"
                        [placeholder]="getFilterLable(e.label) | translate">
                                                        </textarea>
                                                  </div>
                                             </div>

                                             <!-- DropDown List  -->
                                             <div *ngIf="e['type']==='list'" class="mb-2">
                                                  <div class="d-flex align-items-center">
                      <select required="{{e['required']==1}}" [(ngModel)]="form.data[e.code]"
                        class="form-select form-select-sm" id="{{e.code}}" name="{{e.code}}">
                        <option value="0">{{ 'SUPPORT_TICKET.Select Option' | translate }} {{e.code | translate}}
                        </option>
                        <option *ngFor="let c of e['values']" value="{{c}}">{{c | translate}}
                                                            </option>
                                                       </select>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              <hr class="border-bottom pt-2">
                              <!-- Save Button -->
                              <div class="mb-3 row">
                                   <div class="col d-flex justify-content-end">
                <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="!uiForm.valid"
                  (click)="save()">
                  <i class="fa fa-save"></i> {{ 'SUPPORT_TICKET.Save' | translate }}
                                        </button>
                <button type="button" class="btn btn-outline-primary btn-sm ms-1" routerLink="/supportticketlist">
                  <i class="fa fa-list fs-6"></i> {{ 'SUPPORT_TICKET.List' | translate }}
                                        </button>
                                   </div>
                              </div>
                         </form>
                    </div>
               </div>
          </div>
     </div>
</div>